const orientationChangeFunctions = [];

function orientationChangeHandler() {
    setTimeout(function() {
        orientationChangeFunctions.forEach(funcRef => funcRef());
    },100);
}
/**
 * Adds a function to a function array, executed on a single orientationchange-event set on window.
 * This avoids the memory load and possible hickups of setting multiple eventlisteners for the same event.
 *
 * @param {Function} handler - function to be called on orientationchange
 * @param {boolean} triggerNow - Should the function be called at once
 */
export function orientationChange(handler, triggerNow = false) {
    // if first call: setup eventlistener on window
    !orientationChangeFunctions.length ? initOrientationChange() : null;

    // Trigger function
    triggerNow ? handler() : null;

    orientationChangeFunctions.push(handler);
}


export function initOrientationChange() {
    window.addEventListener('orientationchange', orientationChangeHandler);
}
